<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="车牌/车主名称/单位名称/联系人名称/主机名称/分组名称"
             style="width: 300px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" size="small" :start-date="new Date()" placement="bottom-end"
                  placeholder="到费日期范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <client-info-detail-modal v-model="clientInfoDetailModal" :initValue="clientInfoDetailId"
                              @on-success="onModifySuccess"></client-info-detail-modal>
    <potential-detail-modal v-model="potentialVehicleInfoDetailModal" :initValue="potentialVehicleInfoDetailId"
                            @on-success="onModifySuccess"></potential-detail-modal>
    <combo-vehicle-info-detail-modal v-model="comboVehicleInfoDetailModal" :initValue="comboVehicleInfoDetailId"
                                     @on-success="onModifySuccess"></combo-vehicle-info-detail-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <combo-vehicle-pub-info-detail-modal v-model="comboVehiclePubInfoDetailModal"
                                         :initValue="comboVehiclePubInfoDetailId"
                                         @on-success="onModifySuccess"></combo-vehicle-pub-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>

import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import PotentialDetailModal from '@/view/crm/components/potential-detail-modal'
import ComboVehicleInfoDetailModal from '@/view/crm/components/combo-vehicle-info-detail-modal'
import ClientInfoDetailModal from '@/view/crm/components/client-info-detail-modal'
import ComboVehiclePubInfoDetailModal from '@/view/crm/components/combo-vehicle-pub-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'usergroupvehicleinfobusinessnotes',
  components: {
    BusinessNoteDetailModal,
    VehicleInfoDetailModal,
    PotentialDetailModal,
    ClientInfoDetailModal,
    ComboVehicleInfoDetailModal,
    ComboVehiclePubInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 业务员选项
      businessUsers: [],
      businessFilter: null,

      totalElements: 0,
      content: [],
      pageSize: 0,

      // 公开信息
      comboVehiclePubInfoDetailModal: false,
      comboVehiclePubInfoDetailId: null,

      colorLabelFilter: null,
      businessNoteTypeFilter: null,

      // 客户信息详细信息
      clientInfoDetailModal: false,
      clientInfoDetailId: null,

      // 潜在合拼车辆信息
      comboVehicleInfoDetailModal: false,
      comboVehicleInfoDetailId: null,

      // 潜在客户车辆详细信息
      potentialVehicleInfoDetailModal: false,
      potentialVehicleInfoDetailId: null,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 业务笔记详细信息
      businessNoteDetailModal: false,
      businessNoteDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        clientInfoId: null,
        vehicleInfoId: null,
        potentialVehicleInfoId: null,
        comboVehicleInfoId: null,
        comboVehicleInfo: null
      },

      pubBusinessStateFilter: null,
      startDate: null,
      endDate: null,
      dateFilter: [],
      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: '车牌',
          resizable: true,
          tooltip: 'true',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            return h('Button', {
              props: {
                size: 'small',
                disabled: false
              },
              style: {
                backgroundColor: calRegistrationColor(params.row.comboVehicleInfo.registrationColor),
                color: calRegistrationTextColor(params.row.comboVehicleInfo.registrationColor)
              },
              on: {
                click: () => {
                  this.onDetailClick(params.row.comboVehicleInfo.id)
                }
              }
            }, params.row.comboVehicleInfo.registrationNum)
          }
        },
        {
          title: '分组/单位/车主',
          resizable: true,
          key: 'groupName',
          tooltip: 'true',
          width: 420,
          // maxWidth: 450,
          render: function (h, params) {
            return h('div', [
              h('div', params.row.comboVehicleInfo.groupName),
              h('div', params.row.comboVehicleInfo.customCompanyName),
              h('div', params.row.comboVehicleInfo.vehicleOwnerName)
            ])
          }
        },
        // {
        //   title: '车主名称',
        //   key: 'vehicleOwnerName',
        //   tooltip: 'true',
        //   minWidth: 180
        // },
        // {
        //   title: '单位名称',
        //   key: 'customCompanyName',
        //   tooltip: 'true',
        //   minWidth: 200
        // },
        {
          title: '主机名称',
          resizable: true,
          tooltip: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.comboVehicleInfo.deviceName)
          }
        },
        {
          title: '到费期',
          resizable: true,
          key: 'comboVehicleInfo.serviceMatureDate',
          sortable: 'custom',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.comboVehicleInfo.serviceMatureDate) {
              let d = new Date(params.row.comboVehicleInfo.serviceMatureDate)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '关联业务员',
          resizable: true,
          key: 'comboVehicleInfo.businessNotes',
          tooltip: 'true',
          width: 160,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.businessFilter = []
              val.forEach(item => {
                this.businessFilter.push(genQueryParam('userId', 'EQ', item))
              })
            } else {
              this.businessFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.comboVehicleInfo.businessNotes) {
              let businessNotes = params.row.comboVehicleInfo.businessNotes
              let display = []
              businessNotes.forEach(item => {
                let displayName = null
                if (item.user.realName) {
                  displayName = item.user.realName
                } else if (item.user.nickName) {
                  displayName = item.user.nickName
                } else if (item.user.name) {
                  displayName = item.user.name
                }
                display.push(
                  h('Button', {
                    props: {
                      type: 'default',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '2px'
                    },
                    on: {
                      click: () => {
                        this.businessNoteInfo.comboVehicleInfoId = params.row.comboVehicleInfoId
                        this.businessNoteDetailId = item.id
                        this.businessNoteInfo.id = item.id
                        this.businessNoteDetailModal = true
                      }
                    }
                  }, displayName))
              })
              return h('div', display)
            }
          }
        },
        {
          title: '笔记内容',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          minWidth: 300,
          render: (h, params) => {
            let businessNotes = params.row.comboVehicleInfo.businessNotes
            let display = []
            businessNotes.forEach(item => {
              let displayName = null
              if (item.user.realName) {
                displayName = item.user.realName
              } else if (item.user.nickName) {
                displayName = item.user.nickName
              } else if (item.user.name) {
                displayName = item.user.name
              }

              let bs = null
              const state = item.businessState
              if (state === 1) {
                bs = h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '待开发')
              } else if (state === 3) {
                bs = h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '继续沟通')
              } else if (state === 4) {
                bs = h('Tag', {
                  props: {
                    color: 'black'
                  }
                }, '沟通未果')
              } else if (state === 11) {
                bs = h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '同意入网')
              } else {
                bs = h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '未定义')
              }

              let tag = h('Row', [displayName, bs, item.content])

              // let displayItem = h('div', [tag])
              display.push(tag)
            })

            return h('div', display)
          }
        }
        // {
        //   title: '公开状态',
        //   tooltip: 'true',
        //   minWidth: 140,
        //   filters: [
        //     {label: '待开发', value: 1},
        //     {label: '继续沟通', value: 3},
        //     {label: '沟通未果', value: 4},
        //     {label: '同意入网', value: 11}
        //   ],
        //   filterMultiple: false,
        //   filterRemote: (val) => {
        //     if (val.length > 0) {
        //       this.pubBusinessStateFilter = genQueryParam('comboVehicleInfo.pubBusinessState', 'EQ', val[0])
        //     } else {
        //       this.pubBusinessStateFilter = null
        //     }
        //   },
        //   render: (h, params) => {
        //     if (params.row.comboVehicleInfo.pubBusinessState) {
        //       const state = params.row.comboVehicleInfo.pubBusinessState;
        //       if (state === 1) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'red'
        //             }
        //           }, '待开发')
        //         ])
        //       } else if (state === 3) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'blue'
        //             }
        //           }, '继续沟通')
        //         ])
        //       } else if (state === 4) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'black'
        //             }
        //           }, '沟通未果')
        //         ])
        //       } else if (state === 11) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'green'
        //             }
        //           }, '同意入网')
        //         ])
        //       }
        //     } else {
        //       return h('div', [
        //         h('Tag', {
        //           props: {
        //             type: 'dot',
        //             color: 'red'
        //           }
        //         }, '待开发')
        //       ])
        //     }
        //   }
        // },
        // {
        //   title: '公开备注',
        //   key: 'pubRemark',
        //   tooltip: 'true',
        //   minWidth: 150,
        //   render: (h, params) => {
        //     return h('div', params.row.comboVehicleInfo.pubRemark)
        //   }
        // },
        // {
        //   title: '操作',
        //   key: 'action',
        //   align: 'left',
        //   ellipsis: 'true',
        //   minWidth: 80,
        //   fixed: 'right',
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           type: 'primary',
        //           size: 'small',
        //           disabled: false,
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.comboVehiclePubInfoDetailId = params.row.comboVehicleInfo.id
        //             this.comboVehiclePubInfoDetailModal = true
        //           }
        //         }
        //       }, '公开信息')
        //     ])
        //   }
        // }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'BusinessNoteServ_GetMyPage',
      'UserServ_GetAllUsers'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.setPage(1)
    },
    onDetailClick (id) {
      this.comboVehicleInfoDetailId = id
      this.comboVehicleInfoDetailModal = true
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true
      let qo1 = null
      let queryParams = []
      let sortParam = null
      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('comboVehicleInfo.serviceMatureDate', 'BTDT', this.startDate, this.endDate))
      }
      if (this.pubBusinessStateFilter) {
        queryParams.push(this.pubBusinessStateFilter)
      }
      if (this.businessFilter) {
        qo1 = this.businessFilter
      }
      store.dispatch('BusinessNoteServ_GetComboVehicleInfoNotePage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.totalElements = store.getters.get_BusinessNote_GetComboVehicleInfoNotePageResult.totalElements
        this.content = store.getters.get_BusinessNote_GetComboVehicleInfoNotePageResult.content
        this.pageSize = store.getters.get_BusinessNote_GetComboVehicleInfoNotePageResult.size
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [3, 7, 8] }
      }).then(() => {
        let businessUsers = store.getters.get_User_GetAllUsersResult
        this.businessUsers = businessUsers.map(item => {
          return { label: item.realName, value: item.id }
        })
        this.columns[4].filters = this.businessUsers
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
